import { Typography } from '@mui/material'
import { forwardRef } from 'react'
import { ToggleInputField, ToggleInputFieldProps } from 'utoniq-ui'

import { CellFrame } from '@/core/architecture'

export const ToggleInputCell = forwardRef(
  (
    {
      sx,
      description,
      ...props
    }: Omit<ToggleInputFieldProps, 't'> & { description?: string },
    ref
  ) => (
    <CellFrame>
      <ToggleInputField
        {...props}
        inputRef={ref}
        sx={{
          px: 0,
          pt: 0,
          '&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
            bgcolor: 'primary.main',
          },
        }}
      />
      <Typography variant="caption" color="text.secondary">
        {description}
      </Typography>
    </CellFrame>
  )
)
